<template>
  <div class="system-class-item-list mt-40">
    <div
      v-for="(system,systemIndex) in systemClasses"
      :key="systemIndex"
      class="system-class-item-list__item-wrap"
    >
      <WsText001
        h3
        bold
      >
        {{ system.name }}
      </WsText001>
      <div
        v-for="(subclass,subclassIndex) in system.system_subclasses"
        :key="subclassIndex"
        class="system-class-item-list__item-content"
      >
        <WsIconTitle001 :image="subclass.icon">
          {{ subclass.name }}
        </WsIconTitle001>
        <div class="system-class-item-list__items mt-20">
          <slot
            :systemClass="system.id"
            :systemSubclass="subclass.id"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlSystemClassItemList",
  props: {
    systemClasses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-system-class-item-list";
</style>